import * as React from 'react';
import { IconChevronLeft16 } from '@cian/ui-kit';
import { debounce } from 'throttle-debounce';

import * as style from './PrevButton.css';
import { TABLE_SCROLL_BUTTON_DELAY } from '../../constants/delays';

export interface IPrevButtonProps {
  first: boolean;
  onClick: () => void;
}

export const PrevButton = ({ first, onClick }: IPrevButtonProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedHandleClick = React.useCallback(debounce(TABLE_SCROLL_BUTTON_DELAY, onClick), [onClick]);

  if (first) {
    return null;
  }

  return (
    <div onClick={debouncedHandleClick} className={style['container']}>
      <IconChevronLeft16 color={'white_100'} />
    </div>
  );
};
